import { TailwindSandboxPure } from "@/modules/cms/views/post/components/builder/Content/TailwindSandbox"

import { parseFilters } from "../../utils"

import { useFilters } from "./context"

const Preview = ({ type }) => {
  const defaultClasses = 'rounded-lg shadow-lg size-32'

  const { filters } = useFilters()
  const filterClasses = parseFilters({ [type]: filters?.[type] })

  return <>
    Preview
    <div className='my-2'>
      <TailwindSandboxPure className='w-full h-[140px]'>
        <div className="flex items-center justify-center flex-col gap-2 h-full relative">
          <div className={`absolute size-20 bg-white/30 ${type === 'backdrop' ? filterClasses : 'hidden'}`}></div>
          <img
            src="https://images.unsplash.com/photo-1554629947-334ff61d85dc?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&h=1000&q=90"
            className={`${defaultClasses} ${type === 'filter' && filterClasses}`}
            alt="Kitten normal"
          />
        </div>
      </TailwindSandboxPure>
    </div>
  </>
}

export default Preview
